import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#EDEDED',
    padding: theme.spacing(10),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    marginBottom: theme.spacing(0.25),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
    },
  },
  title: {
    fontSize: 25,
    lineHeight: '25px',
    color: '#273A42 !important',
    marginBottom: theme.spacing(2),
    '& > a': {
      color: '#273A42 !important',
    },
    '& > a:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  description: {
    fontSize: 18,
    lineHeight: '22px',
    marginBottom: theme.spacing(2),
  },
  publicationDate: {
    fontSize: 15,
    color: '#707070',
  },
  category: {
    fontSize: 15,
    color: '#707070',
    '& > .key': {
      fontWeight: 'bold',
    },
    '& > .value': {
      textTransform: 'capitalize',
    },
  },
}));

function SearchItem(props) {
  const classes = useStyles();
  const { item, url } = props;
  const { t } = useTranslation();

  return (
    <article className={classes.root}>
      <Typography component="div" className={classes.title}>
        <NavLink to={url}>{item.title}</NavLink>
      </Typography>
      <Typography
        className={classes.description}
        dangerouslySetInnerHTML={{
          __html: item.description,
        }}
      />
      <Typography className={classes.publicationDate}>
        {t('SEARCH.ITEM.DATE')}: {item.timeFormatted}
      </Typography>
      <Typography className={classes.category}>
        <span className="key">{t('SEARCH.ITEM.CATEGORY')}: </span>
        <span className="value">{item.type}</span>
      </Typography>
    </article>
  );
}

SearchItem.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  url: PropTypes.string,
};

export default SearchItem;
